"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.importCounterGroups = exports.update = exports.create = exports.fetchAll = exports.fetch = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const counterGroupsService_1 = require("./service/counterGroupsService");
const Env_1 = require("../../utils/tsUtils/Env");
exports.fetch = (0, toolkit_1.createAsyncThunk)('counterGroups/fetch', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const counterGroupService = new counterGroupsService_1.CounterGroupService(Env_1.APIPATHENV);
        const response = yield counterGroupService.fetch(payload);
        return response;
    }
    catch (error) {
        throw new Error("Failed to fetch counter groups");
    }
}));
exports.fetchAll = (0, toolkit_1.createAsyncThunk)('counterGroups/fetchAll', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const counterGroupService = new counterGroupsService_1.CounterGroupService(Env_1.APIPATHENV);
        const response = yield counterGroupService.fetch(payload);
        return response;
    }
    catch (error) {
        throw new Error("Failed to fetch counter groups");
    }
}));
exports.create = (0, toolkit_1.createAsyncThunk)('counterGroups/create', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const counterGroupService = new counterGroupsService_1.CounterGroupService(Env_1.APIPATHENV);
        const response = yield counterGroupService.create(payload);
        return response;
    }
    catch (error) {
        throw new Error("Failed to create counter group");
    }
}));
exports.update = (0, toolkit_1.createAsyncThunk)('counterGroups/update', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const counterGroupService = new counterGroupsService_1.CounterGroupService(Env_1.APIPATHENV);
        const response = yield counterGroupService.update(payload);
        return response;
    }
    catch (error) {
        throw new Error("Failed to update counter group");
    }
}));
exports.importCounterGroups = (0, toolkit_1.createAsyncThunk)('counterGroups/import', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const counterGroupService = new counterGroupsService_1.CounterGroupService(Env_1.APIPATHENV);
        const response = yield counterGroupService.importCsv(payload);
        return response;
    }
    catch (error) {
        throw new Error(error.message || "Failed to import counter group");
    }
}));
